/*
 * API do Projeto
 *
 * API Desenv: api = 'https://desenv-dot-cryptolands-d51d1.appspot.com/v1/';
 * API Homologacao: api = 'https://homologacao-dot-cryptolands-d51d1.appspot.com/v1/';
 * API Release (producao): api = 'https://cryptolands-d51d1.appspot.com/v1/'; 'https://release-1-5-2-dot-cryptolands-d51d1.appspot.com/';
 */

declare var firebase;

class Const {
  // api = 'http://localhost:8080/v1/';
  // api = 'https://homologacao-dot-cryptolands-d51d1.appspot.com/v1/';
  // api = 'https://desenv-dot-cryptolands-d51d1.appspot.com/v1/';
  api = 'https://cryptolands-d51d1.appspot.com/v1/';
  apiFee = "https://bitcoinfees.earn.com/api/v1/fees/list";

  path = {
    home: "home",
    ngos: "ngos",
    assets: "assets",
    hallOfFame: "hallOfFame",
    profiles: "profiles",
    transfer: "transfer",
    buyAsset: "buyAsset",
    confirmBuy: "confirmBuy",
    ticker: "ticker",
    tfa: "tfa",
    auction: "auction",
    donation: "donation"
  };

  authorization = "Bearer ";

  constructor() {
    let token = localStorage.getItem("token");

    if (firebase.auth().currentUser && firebase.auth().currentUser.pa) {
      this.authorization += firebase.auth().currentUser.pa;
      localStorage.setItem("token", firebase.auth().currentUser.pa);
    } else if (token) {
      this.authorization = "Bearer " + token;
    }

    firebase.auth().onIdTokenChanged(user => {
      if (user && user.pa) {
        localStorage.setItem("token", user.pa);
        this.authorization = "Bearer " + user.pa;
      }
    });

    firebase.auth().onAuthStateChanged(user => {
      if (user && user.pa) {
        this.authorization = "Bearer " + user.pa;
        localStorage.setItem("token", user.pa);
      }
    });
  }
}

export default new Const();



// WEBPACK FOOTER //
// ./src/utils/consts.js